import { formatPrice, round } from '../../Controllers/utils';
import {
    StockInfoContainer,
    StockInfoTextBoxLeft,
    StockInfoTextBoxCenter,
    StockInfoTextBoxRight,
} from '../StyledComponents/StockCardStyledComponents';
import { DirectionDownIcon, DirectionMoveIcon, DirectionUpIcon } from '../Icons/Icons';

const StockInfo = ({ cardDimensions, data }) => {
    let moveDirection;
    let moveColor;
    let plusSign;
    
    if (round(data?.date_return_oc * 100, 1) > 0 ) {
        plusSign = '+'
        moveDirection = <DirectionUpIcon/>;
        moveColor ='MRGREEN';
    } else if (round(data?.date_return_oc * 100, 1) < 0){
        moveDirection = <DirectionDownIcon/>;
        moveColor ='MRRED';
    } else if (round(data?.date_return_oc * 100, 1) === 0 ){
        moveDirection = <DirectionMoveIcon/>;
        moveColor ='MRLITE80';
    }

    return (
        <StockInfoContainer cardDimensions={cardDimensions?.data} moveColor={moveColor}>
            <StockInfoTextBoxLeft>
                {data?.symbol}
            </StockInfoTextBoxLeft>

            <StockInfoTextBoxCenter>
                {formatPrice(data?.close)}
            </StockInfoTextBoxCenter>

            <StockInfoTextBoxRight>
                {plusSign}{round(data?.date_return_oc * 100, 1)}% 
                {moveDirection} 
            </StockInfoTextBoxRight>
        </StockInfoContainer>
    )
};

export default StockInfo;
